import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Grid, Typography, Link, IconButton, } from '@mui/material';
import { useNavigate } from 'react-router';
import { observer } from 'mobx-react-lite';
import { useStore, } from '@mcn-platform/models';
import X from '@mui/icons-material/X';
import Instagram from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Facebook from '../icons/Facebook';
import linkNavigator from '../common/linkNavigator';
import AssetImage from '../common/asset/AssetImage';
import PlaceHolder from '../common/PlaceHolder';
import InstructorItemList from './InstructorItemList';
const SocialIcons = ({ instructor }) => {
    const navigate = useNavigate();
    const { linkedInUrl, youtubeUrl, instagramUrl, twitterUrl, facebookUrl, } = instructor;
    const icons = [];
    if (linkedInUrl) {
        icons.push({
            link: linkedInUrl,
            icon: _jsx(LinkedInIcon, {}),
        });
    }
    if (youtubeUrl) {
        icons.push({
            link: youtubeUrl,
            icon: _jsx(YouTubeIcon, {}),
        });
    }
    if (instagramUrl) {
        icons.push({
            link: instagramUrl,
            icon: _jsx(Instagram, {}),
        });
    }
    if (twitterUrl) {
        icons.push({
            link: twitterUrl,
            icon: _jsx(X, {}),
        });
    }
    if (facebookUrl) {
        icons.push({
            link: facebookUrl,
            icon: _jsx(Facebook, {}),
        });
    }
    return (_jsx(Box, { sx: { ml: { xs: 0, md: '-8px' } }, children: icons.map((i) => (_jsx(IconButton, { sx: { color: (theme) => theme.palette.indigoCustom[700] }, onClick: () => {
                linkNavigator({ url: i.link, type: 'social' }, navigate);
            }, children: i.icon }))) }));
};
const InstructorDetail = ({ instructorID, editData, }) => {
    const store = useStore();
    if (editData) {
        return (_jsx(PlaceHolder, { placeHolderName: "Instructor Detail" }));
    }
    if (!instructorID) {
        return _jsx("div", { children: "\u00A0" });
    }
    const instructor = store.getOrLoad('instructor', instructorID);
    if (!instructor) {
        return _jsx("div", { children: "\u00A0" });
    }
    const getMailLink = () => (`mailto:${instructor.email}`);
    return (_jsxs(Box, { sx: {
            width: '100%',
            maxWidth: 1200,
            marginX: 'auto',
            my: 3,
        }, children: [_jsxs(Grid, { container: true, sx: { mb: 2 }, children: [_jsxs(Grid, { item: true, xs: 12, md: 8, sx: { px: 2, textAlign: { xs: 'center', md: 'left' } }, order: { xs: 2, md: 0 }, children: [_jsx(Typography, { variant: "h2", fontWeight: "fontWeightBold", color: "textPrimary", sx: { mt: { xs: 2, md: 0 } }, className: "instructor", children: instructor.name }), instructor.email ? (_jsx(Link, { href: getMailLink(), sx: { textDecoration: 'none', mb: '5px', display: 'inline-block' }, children: instructor.email })) : '', _jsx(SocialIcons, { instructor: instructor }), _jsxs(Box, { sx: { mt: 2, p: 0 }, children: [_jsx(Typography, { variant: "h4", sx: { borderBottom: 1, borderColor: 'contract.main', display: 'inline-block' }, children: "About" }), _jsx(Typography, { sx: { mt: 1, whiteSpace: 'pre-line' }, variant: "body1", className: "description", children: instructor.biography })] })] }), _jsx(Grid, { item: true, xs: 12, md: 3, sx: { px: 2, textAlign: 'center' }, order: { xs: 1, md: 0 }, children: _jsx(Box, { sx: {
                                borderRadius: '50%',
                                width: '250px',
                                height: '250px',
                                overflow: 'hidden',
                                margin: { xs: '0 auto', md: '40% auto 0 45px' },
                                ml: { xs: 'auto', md: 3 },
                            }, children: _jsx(AssetImage, { asset: instructor.profileImage, customStyle: {
                                    maxWidth: '100%',
                                }, size: "thumb400w" }) }) })] }), store.currentPortal && instructor.syncState === 'loaded' && (_jsx(InstructorItemList, { instructorName: instructor.name }))] }));
};
InstructorDetail.defaultProps = {
    editData: undefined,
};
InstructorDetail.meta = {
    group: 'landingPages',
    name: 'Instructor Delivery Panel',
    description: 'Displays the full instructor delivery interface.',
    props: [
        {
            key: 'instructorID',
            returnId: true, // hack to to make the picker return the course ID
            name: 'instructor',
            type: 'instructor', // note this is a special type recognized by the system
            description: 'The instructor being delivered.',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'InstructorDetail',
        props: {
            instructorID: '@instructorID',
        },
    },
};
export default observer(InstructorDetail);
//# sourceMappingURL=InstructorDetail.js.map